import { motion } from "framer-motion";
import { Music } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { useBooking } from "@/context/BookingContext";
import { useContent } from "@/context/ContentContext";

export const Events = () => {
  const { content } = useContent();
  const { openTour } = useBooking();
  const EVENTS = content.events || [];
  return (
    <section id="events" data-testid="events" className="bg-[#eae4d8] px-6 py-28 lg:px-10 lg:py-40">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
            <div>
              <div className="overline mb-6">Four seasons, four gatherings</div>
              <h2 className="max-w-2xl font-serif text-4xl font-medium leading-tight tracking-tight text-[#23281f] lg:text-6xl">
                Mountain Music <span className="italic text-[#ba5a45]">Events.</span>
              </h2>
            </div>
            <p className="max-w-sm text-[#5c6157]">
              One gathering for every season — acoustic nights, folk, and fire in the heart of the
              Garhwal Himalaya.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {EVENTS.map((e, i) => (
            <motion.div
              key={e.season + i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group flex flex-col overflow-hidden border border-[#ddd6c8] bg-[#f4f1ea]"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={e.image} alt={e.title} className="img-zoom h-full w-full object-cover" />
                <span className="absolute left-4 top-4 rounded-none bg-black/45 px-2.5 py-1 text-[10px] uppercase tracking-[0.18em] text-[#f2e4c9] backdrop-blur-sm">
                  {e.season}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <div className="text-xs uppercase tracking-[0.15em] text-[#8a7a62]">{e.months}</div>
                <h3 className="mt-2 font-serif text-2xl text-[#23281f]">{e.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-[#5c6157]">{e.body}</p>
                <button
                  data-testid={`event-enquire-${i}`}
                  onClick={() => openTour("Mountain Music Events")}
                  className="mt-5 inline-flex w-fit items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#ba5a45] transition-colors hover:text-[#9c4633]"
                >
                  <Music className="h-3.5 w-3.5" /> Enquire
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
